/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { IncomingAttachment } from "./IncomingAttachment";
import type { IncomingCarePlan } from "./IncomingCarePlan";
import type { IncomingClinicianBio } from "./IncomingClinicianBio";
import type { IncomingOutputText } from "./IncomingOutputText";
import type { IncomingSystem } from "./IncomingSystem";
import type { IncomingVideoVisitEnded } from "./IncomingVideoVisitEnded";
import type { IncomingVideoVisitStarted } from "./IncomingVideoVisitStarted";

export interface IncomingEventModel {
  conversation_id: string;
  /** Preferred identifier for resolving the target conversation. When set, the event is routed via this ClinicRequest, which pins a specific visit; falls back to conversation_id when absent. conversation_id alone only tracks the most recent visit once a CHAI conversation has multiple. */
  clinic_request_id?: string | null;
  conversation_owner_id: string;
  sender_full_name_with_title?: string | null;
  sender_photo_url?: string | null;
  deduplication_id: string;
  event:
    | IncomingOutputText
    | IncomingCarePlan
    | IncomingClinicianBio
    | IncomingSystem
    | IncomingAttachment
    | IncomingVideoVisitStarted
    | IncomingVideoVisitEnded;
}
